import { TYPES } from "./default_setting.type";

const initState = {
  defaultSettingBailiff: null,
};

const defaultSettingReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_SETTING_BAILIFF:
      return {
        ...state,
        defaultSettingBailiff: payload,
      };

    default:
      return state;
  }
};

export default defaultSettingReducer;
